import React, { useState, useRef ,useEffect, ChangeEvent } from "react";
import { auth, firestore } from "../firebaseConfig"; // Assicurati che il percorso sia corretto
import { collection, getDocs, doc, getDoc, setDoc, onSnapshot } from "firebase/firestore";
import { motion, AnimatePresence } from 'framer-motion';
import verde from "../images/Frame 17.png"
import Matt from "../images/Frame 20.png"
import rosso from "../images/Frame 18.png"
import blu from "../images/Blu.png"
import giallo from "../images/Giallo.png"
import arancione from "../images/Arancione.png"
import vuoto from "../images/Frame 19.png"
import beach from "../images/beach.png"
import mattonella from "../images/mattonella.png"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { deleteDoc, addDoc, updateDoc } from 'firebase/firestore';
import { Timestamp, getFirestore} from 'firebase/firestore';
import { it } from "date-fns/locale";
import "../styles.css"
interface Model {
  id: string,
  posizione: number,
  tipologia: string,
  Assenze: Assenza[]
  prenotazioni: Prenotazione[];
}
interface Model2 {
  Colonne: number;
  File: number
  Nome: string,
  
}
interface UscitaOggi {
  ombrelloneId: string;
  nome: string;
}
interface Prenotazione {
  Nome: string;
  Tipo: "Giornaliero" | "Intervallo" | "Stagionale" | "Annuale";
  datainizio: string;   
  dataFine: string;   
  occupazioneAssenza?: boolean;
}
interface Assenza {
  dataInizio: string; // Data inizio assenza
  dataFine: string;   // Data fine assenza
}

// ──────────────────────────────────────────────────────────────────────────
// LAYOUT SPIAGGIA
// Descrizione dichiarativa della FORMA della spiaggia: 3 zone affiancate
// (Napoli a sinistra, Centro, Roma a destra). Ogni zona ha una lista di "file".
// Una fila può essere:
//   - { tipo: "scacchiera", avanti, dietro } → due linee sfalsate. La linea
//     "dietro" è spostata di mezza posizione e sta negli spazi vuoti di quella
//     "avanti" (per questo ha un ombrellone in meno).
//   - { tipo: "linea", n }                   → una linea normale da n ombrelloni.
// L'ordine in cui zone/file/ombrelloni compaiono qui determina l'indice
// (Posizione) di ogni posto: Napoli 0..N, poi Centro, poi Roma. Gli ombrelloni
// salvati su Firebase vengono mostrati in base al loro campo Posizione: NON
// tocchiamo i dati, cambia solo la disposizione a schermo.
// ──────────────────────────────────────────────────────────────────────────
// DUE VERSIONI nello stesso Firestore, selezionabili con lo switch in alto:
//   1 = versione "vecchia": griglia rettangolare + collection "Ombrelloni"
//   2 = versione "nuova": layout a 3 aree/scacchiera + collection "OmbrelloniV2"
// Ogni versione legge/scrive SOLO sulla propria collection: i dati non si
// mischiano e quelli della V1 restano al sicuro.
const COLLEZIONI: { [versione: number]: string } = {
  1: "Ombrelloni",
  2: "OmbrelloniV2",
};

const CELL_VW = 1.5;   // larghezza di un posto (in vw)
const GAP_VW = 0.25;   // spazio tra i posti (in vw)

interface Fila {
  tipo: "scacchiera" | "linea";
  avanti?: number;
  dietro?: number;
  n?: number;
}
interface ZonaConfig {
  nome: string;
  file: Fila[];
}

const LAYOUT_SPIAGGIA: ZonaConfig[] = [
  {
    nome: "Napoli",
    file: [
      { tipo: "scacchiera", avanti: 13, dietro: 12 },
      { tipo: "scacchiera", avanti: 13, dietro: 12 },
      { tipo: "scacchiera", avanti: 13, dietro: 12 },
      { tipo: "linea", n: 20 },
      { tipo: "linea", n: 20 },
    ],
  },
  {
    nome: "Centro",
    file: [
      { tipo: "scacchiera", avanti: 6, dietro: 5 },
      { tipo: "scacchiera", avanti: 6, dietro: 5 },
      { tipo: "scacchiera", avanti: 6, dietro: 5 },
      { tipo: "linea", n: 9 },
      { tipo: "linea", n: 9 },
    ],
  },
  {
    nome: "Roma",
    file: [
      { tipo: "scacchiera", avanti: 12, dietro: 11 },
      { tipo: "scacchiera", avanti: 12, dietro: 11 },
      { tipo: "scacchiera", avanti: 12, dietro: 11 },
      { tipo: "linea", n: 18 },
      { tipo: "linea", n: 18 },
    ],
  },
];

interface LineaLayout {
  slots: number[];      // indici (Posizione) dei posti di questa linea
  gapVw: number;        // spazio tra i posti di QUESTA linea (in vw)
  marginLeftVw: number; // offset a sinistra (per la fila "dietro" sfalsata)
}
interface FilaLayout {
  lines: LineaLayout[];
}
interface ZonaLayout {
  nome: string;
  file: FilaLayout[];
  widthVw: number; // larghezza totale dell'area (in vw)
}

// Trasforma la configurazione in una struttura pronta da disegnare.
// Assegna a ogni posto un indice progressivo (= Posizione su Firebase) e
// calcola la geometria di ogni linea in modo che TUTTE le file di un'area
// abbiano la stessa larghezza (= la fila più lunga): le file a scacchiera,
// che hanno meno ombrelloni, vengono distribuite con un passo più ampio.
function buildLayout(config: ZonaConfig[]): ZonaLayout[] {
  let idx = 0;
  const next = (n: number): number[] => {
    const arr: number[] = [];
    for (let i = 0; i < n; i++) arr.push(idx++);
    return arr;
  };
  return config.map((zona): ZonaLayout => {
    // Numero di ombrelloni della fila più lunga dell'area
    const conteggi: number[] = [];
    zona.file.forEach((f) => {
      if (f.tipo === "scacchiera") {
        conteggi.push(f.avanti ?? 0, f.dietro ?? 0);
      } else {
        conteggi.push(f.n ?? 0);
      }
    });
    const maxCount = Math.max(...conteggi, 1);
    // Larghezza target dell'area (la fila più lunga, alla spaziatura base)
    const W = maxCount * CELL_VW + (maxCount - 1) * GAP_VW;
    // gap necessario perché `count` ombrelloni occupino esattamente W
    const gapPer = (count: number): number =>
      count > 1 ? (W - count * CELL_VW) / (count - 1) : 0;

    const file = zona.file.map((fila): FilaLayout => {
      if (fila.tipo === "scacchiera") {
        const F = fila.avanti ?? 0;
        const D = fila.dietro ?? 0;
        const gapFront = gapPer(F);
        const pitchFront = CELL_VW + gapFront;
        return {
          lines: [
            // avanti: occupa tutta la larghezza W
            { slots: next(F), gapVw: gapFront, marginLeftVw: 0 },
            // dietro: stesso passo, spostata di mezzo passo → effetto scacchiera
            { slots: next(D), gapVw: gapFront, marginLeftVw: pitchFront / 2 },
          ],
        };
      }
      const C = fila.n ?? 0;
      return { lines: [{ slots: next(C), gapVw: gapPer(C), marginLeftVw: 0 }] };
    });
    return { nome: zona.nome, file, widthVw: W };
  });
}

const LAYOUT: ZonaLayout[] = buildLayout(LAYOUT_SPIAGGIA);

// ── FILE IN FONDO: 6 file dritte (no scacchiera) lunghe TUTTO il lido ──
const GAP_OUTER_VW = GAP_VW * 2; // spazio tra le colonne (aree e divisori)
// Numero di posti già usati dalle 3 aree: da qui continuano gli indici.
const SLOTS_USED = LAYOUT.reduce(
  (tot, z) =>
    tot +
    z.file.reduce(
      (f, fila) => f + fila.lines.reduce((l, ln) => l + ln.slots.length, 0),
      0
    ),
  0
);
// Larghezza totale del lido = 3 aree + 2 divisori + 4 spazi tra le colonne.
const TOTAL_W =
  LAYOUT.reduce((s, z) => s + z.widthVw, 0) + 2 * CELL_VW + 4 * GAP_OUTER_VW;
const BOTTOM_ROWS = 6;
// Quanti ombrelloni servono per coprire tutta la larghezza alla spaziatura base.
const BOTTOM_COUNT = Math.max(
  1,
  Math.floor((TOTAL_W + GAP_VW) / (CELL_VW + GAP_VW))
);
// gap che fa coprire esattamente l'intera larghezza del lido.
const BOTTOM_GAP_VW =
  BOTTOM_COUNT > 1 ? (TOTAL_W - BOTTOM_COUNT * CELL_VW) / (BOTTOM_COUNT - 1) : 0;
// Indici (Posizione) progressivi per le 6 file in fondo.
const BOTTOM_LINES: number[][] = (() => {
  const rows: number[][] = [];
  let idx = SLOTS_USED;
  for (let r = 0; r < BOTTOM_ROWS; r++) {
    const row: number[] = [];
    for (let c = 0; c < BOTTOM_COUNT; c++) row.push(idx++);
    rows.push(row);
  }
  return rows;
})();

function Home() {

// STATI GENERALI
const [loading, setloading] = useState(false); // Usa il tipo Model[]
const [action, setaction] = useState("select"); // Usa il tipo Model[]
const [listPosition, setListPosition] = useState<{ x: number; y: number } | null>(null); //gestisci posizione UI gestisci date
const [intervallo, setintervallo] = useState("Giorno"); // Intervallo / giorno
const [aggiungioggetto, setaggiungioggetto] = useState("Ombrellone");  // Aggiungi ombrellone / Mattonella
const [prenotazioneoassenze, setprenotazioneoassenze] = useState("Prenotazioni");  // Aggiungi ombrellone / Mattonella
const [occupaleassenze, setoccupaleassenze] = useState(false);  // Aggiungi ombrellone / Mattonella
const [Menu, setMenu] = useState(false);  // Aggiungi ombrellone / Mattonella
const [cerca, setcerca] = useState(''); // Cerca un utente
const [risultati, setRisultati] = useState<Model[]>([]); // Risultati anagrafica
const [risultatiuscite, setRisultatiuscite] = useState<Model[]>([]);// ombrelloni che oggi escono
const [RisultatiEntrate, setRisultatiEntrate] = useState<Model[]>([]);// ombrelloni che oggi entrano
const [impostazioni, setimpostazioni] = useState('Anagrafica');
// DATE
const datattuale = new Date(); // Data di oggi
const [startDate, setStartDate] = useState<Date | null>(null);  // Data inizio documento selezionato 
const [endDate, setEndDate] = useState<Date | null>(null);  // Data fine documento selezionato 
const [dateinizio, setdateinizio] = useState<Date | null>(new Date()); // Data inizio home
const [datefine, setdatefine] = useState<Date | null>(new Date(new Date().setDate(new Date().getDate() + 1))); // Data fine home 
const [date, setdate] = useState<Date | null>(new Date()); // Data home giorno

//DOCS
const [docs, setDocs] = useState<Model[]>([]); // Tutte le griglie 
const [docsinfo, setInfo] = useState<Model2[]>([]); // Iinfo generali
const [selectedDoc, setSelectedDoc] = useState<Model | null>(null); // Ombrellone selezionato
const [Docercato, setdoccercato] = useState<Model | null>(null); // Ombrellone selezionato
const [selectedinvertedDoc1, setSelectedinvertedDoc1] = useState<Model | null>(null); // Ombrellone selezionato da invertire 
const [selectedinvertedDoc2, setSelectedinvertedDoc2] = useState<Model | null>(null); // Ombrellone selezionato da invertire
const [daEliminare, setDaEliminare] = useState<Model | null>(null); // documento in attesa di conferma eliminazione
//PRENOTAZIONI
const [Testoaggiungidata, setestoaggiungidata] = useState(""); // Nome ombrellone
const [selectedValue, setSelectedValue] = useState("Giornaliero"); // Nome ombrellone

// VERSIONE ATTIVA (1 = vecchia, 2 = nuova), persistita in localStorage.
const [versione, setVersione] = useState<number>(() => {
  const raw = Number(localStorage.getItem("versione"));
  return raw === 1 ? 1 : 2; // qualsiasi valore non valido → versione 2
});
const COLLEZIONE = COLLEZIONI[versione] ?? COLLEZIONI[1]; // collection Firestore attiva
const cambiaVersione = (v: number) => {
  // Azzero le selezioni della versione precedente: i loro id non esistono
  // nell'altra collection, quindi salva()/scambia() colpirebbero il documento sbagliato.
  setSelectedDoc(null);
  setdoccercato(null);
  setSelectedinvertedDoc1(null);
  setSelectedinvertedDoc2(null);
  setListPosition(null);
  setDaEliminare(null);
  localStorage.setItem("versione", String(v));
  setVersione(v);
};


//LOADING DATI
useEffect(() => {
 
  let cancelled = false;
  let unsubscribe: (() => void) | null = null;

  const recuperaDati = async () => {
    try {
      const uid = auth.currentUser?.uid;
      if (uid) {
        
//OTTIENI DATI GENERALI DEL PROGETTO
        const docRef = doc(firestore, "Utenti", "regelly150");  
        const docSnapshot = await getDoc(docRef);
        if (cancelled) return; // versione cambiata durante l'attesa: abortisci

        if (docSnapshot.exists()) {
          const data = docSnapshot.data(); 
          setInfo([
            {
              Colonne: data?.Colonne,
              File: data?.File,
              Nome: data?.Nome_progetto,
            },
          ]);
        } else {
          setInfo([{ Colonne: 0, File: 0, Nome: "" }]);
          console.error("Il documento non esiste!");
        }

//OTTIENI ARRAY DI TUTTI I DOCUMENTI (OMBRELLONI E MATTONELLE)

        const collectionRef = collection(firestore, "Utenti", "regelly150", COLLEZIONE);

    
       unsubscribe = onSnapshot(collectionRef, (querySnapshot) => {
          if (cancelled) return; // ignora snapshot di una versione non più attiva

          const arrayDocumenti = querySnapshot.docs.map((doc) => {
            const data = doc.data();
            return {
              id: doc.id,
              posizione: data.Posizione,
              tipologia: data.Tipologia,
              prenotazioni: data.Prenotazioni? data.Prenotazioni : [],
              Assenze: data.Assenze? data.Assenze : []
            };
          });
     
          setDocs(arrayDocumenti);
        });
      } else {
        console.error("Utente non autenticato o UID mancante.");
      }
      
      setloading(true);
    } catch (errore) {
      console.error("Errore durante il recupero dei documenti: ", errore);
    }
  };

  setDocs([]); // svuota subito gli ombrelloni quando si cambia versione
  recuperaDati(); // Chiamata alla funzione per recuperare i dati

  return () => {
    cancelled = true;
    if (unsubscribe) unsubscribe(); // disiscrivi dalla collection precedente
  };
}, [COLLEZIONE]);

useEffect(() => {
  if (selectedDoc) {
    document.body.style.overflow = "hidden";
  }else {
    setTimeout(() => {
      document.body.style.overflow = "visible";



    }, 300); // Stessa durata dell'animazione
}
}, [selectedDoc]);



useEffect(() => {
  const query = cerca.trim().toLowerCase();

 

  const filtered = docs.filter((ombrellone) =>
    ombrellone.prenotazioni.some((prenotazione) => {
      const nomeParole = prenotazione.Nome.toLowerCase().split(' ');
      return nomeParole.some((parola) => parola.startsWith(query));
    })
  );

  setRisultati(filtered);
}, [cerca, docs]);
function parseDMY(d: string | undefined | null): Date | null {
  if (typeof d !== 'string')  return null;

  const parts = d.split('/');
  if (parts.length !== 3) return null;

  const [gg, mm, yyyy] = parts;
  const day = parseInt(gg);
  const month = parseInt(mm) - 1;
  const year = parseInt(yyyy);

  const date = new Date(year, month, day);
  if (isNaN(date.getTime())) return null;

  date.setHours(0, 0, 0, 0);
  return date;
}
useEffect(() => {
  if (!date) return;

  const dataSelezionata = new Date(date);
  dataSelezionata.setHours(0, 0, 0, 0);

  const giornoPrecedente = new Date(dataSelezionata);
  giornoPrecedente.setDate(giornoPrecedente.getDate() - 1);

  const entrateOggi: Model[] = [];
  const usciteOggi: Model[] = [];

  docs.forEach((ombrellone) => {
    let haEntrata = false;
    let haUscita = false;

    for (const prenotazione of ombrellone.prenotazioni) {

      const dataInizio = parseDMY(prenotazione.datainizio);
      const dataFine = parseDMY(prenotazione.dataFine);

      // Entrata: inizia oggi
      if (dataInizio && !haEntrata && dataInizio && dataInizio.getTime() === dataSelezionata.getTime()) {
        entrateOggi.push({
          id: ombrellone.id,
          posizione: ombrellone.posizione,
          Assenze: ombrellone.Assenze,
          prenotazioni: ombrellone.prenotazioni,
          tipologia: ombrellone.tipologia
        });
        haEntrata = true;
      }

      // Uscita: è finito ieri
      if (!haUscita && dataFine && dataFine.getTime() === giornoPrecedente.getTime()) {
        usciteOggi.push({
          id: ombrellone.id,
          posizione: ombrellone.posizione,
          Assenze: ombrellone.Assenze,
          prenotazioni: ombrellone.prenotazioni,
          tipologia: ombrellone.tipologia
        });
        haUscita = true;
      }

      if (haEntrata && haUscita) break; // Ottimizza evitando controlli superflui
    }
  });

  setRisultatiEntrate(entrateOggi);
  setRisultatiuscite(usciteOggi);
}, [docs, date]);


function getNomiEntrate(
  ombrellone: Model,
): string[] {
  if (!date) return [];

  const dataSelezionata = new Date(date);
  dataSelezionata.setHours(0, 0, 0, 0);

  const entrate: string[] = [];

  for (const prenotazione of ombrellone.prenotazioni) {
    const dataInizio = parseDMY(prenotazione.datainizio);

    if (dataInizio && dataInizio.getTime() === dataSelezionata.getTime()) {
      entrate.push(prenotazione.Nome); // oppure prenotazione.nomeCliente
    }
  }

  return entrate;
}
function getNomiUscite(
  ombrellone: Model,
): string[] {
  if (!date) return [];

  const dataSelezionata = new Date(date);
  dataSelezionata.setHours(0, 0, 0, 0);

  // Calcola "ieri"
  const giornoPrecedente = new Date(dataSelezionata);
  giornoPrecedente.setDate(giornoPrecedente.getDate() - 1);

  const uscite: string[] = [];

  for (const prenotazione of ombrellone.prenotazioni) {
    const dataFine = parseDMY(prenotazione.dataFine);

    if (dataFine && dataFine.getTime() === giornoPrecedente.getTime()) {
      uscite.push(prenotazione.Nome); // oppure prenotazione.nomeCliente
    }
  }

  return uscite;
}

const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
  setcerca(e.target.value);
};
const visualizzaPrenotazione = (ombrellone: Model) => {
  setdoccercato(ombrellone)
  setMenu(false)
  // Qui puoi aprire un modal, navigare, ecc.
};
const verificaPrenotazione = (
  ombrellone: Model,

): Prenotazione | null => {
  const convertiStringaInDateSafe = (dataString: string): Date => {
    const result = convertiStringaInDate(dataString);
    if (!(result instanceof Date) || isNaN(result.getTime())) {
      throw new Error(`Data non valida: ${dataString}`);
    }
    return result;
  };

  // Caso 1: Verifica per una singola giornata
  if (intervallo === "Giorno" && date) {
    let prenotazioneValida: Prenotazione | null = null;

    for (const prenotazione of ombrellone.prenotazioni) {
      const dataFinePrenotazione = convertiStringaInDateSafe(prenotazione.dataFine);
      dataFinePrenotazione.setHours(23, 59, 59, 999);

      // Determina dataInizioPrenotazione in base al tipo
      let dataInizioPrenotazione: Date;
      switch (prenotazione.Tipo) {
        case "Giornaliero":
          dataInizioPrenotazione = dataFinePrenotazione;
          break;
        case "Intervallo":
        case "Stagionale":
        case "Annuale":
          dataInizioPrenotazione = convertiStringaInDateSafe(prenotazione.datainizio!); // datainizio è obbligatorio qui
          break;
        default:
          throw new Error(`Tipo prenotazione non riconosciuto: ${prenotazione.Tipo}`);
      }

      const normalizedDate = new Date(date);
      normalizedDate.setHours(0, 0, 0, 0);
      const normalizedFinePrenotazione = new Date(dataFinePrenotazione);
      normalizedFinePrenotazione.setHours(0, 0, 0, 0);
      const normalizedInizioPrenotazione = new Date(dataInizioPrenotazione);
      normalizedInizioPrenotazione.setHours(0, 0, 0, 0);

      const isInRange =
        prenotazione.Tipo === "Giornaliero"
          ? normalizedFinePrenotazione.getTime() === normalizedDate.getTime()
          : normalizedDate >= normalizedInizioPrenotazione &&
            normalizedDate <= normalizedFinePrenotazione;

      if (isInRange) {
        let isCopertoDaAssenza = false;
        for (const assenza of ombrellone.Assenze) {
          const dataInizioAssenza = convertiStringaInDateSafe(assenza.dataInizio);
          const dataFineAssenza = convertiStringaInDateSafe(assenza.dataFine);
          dataFineAssenza.setHours(23, 59, 59, 999);

          const isAssenzaCopreData = dataInizioAssenza <= date && dataFineAssenza >= date;

          if (isAssenzaCopreData) {
            isCopertoDaAssenza = true;
            if (prenotazione.occupazioneAssenza) {
              return prenotazione;
            }
            break;
          }
        }

        if (!isCopertoDaAssenza) {
          prenotazioneValida = prenotazione;
        }
      }
    }

    return prenotazioneValida;
  }

  // Caso 2: Verifica per un intervallo di date
  else if (intervallo === "Intervallo" && dateinizio && datefine) {
    if (dateinizio > datefine) {
      throw new Error("dateinizio non può essere successivo a datefine");
    }

    let intervalloCopertoDaAssenza = false;
    let prenotazioneOccupanteAssenza: Prenotazione | null = null;

    for (const assenza of ombrellone.Assenze) {
      const dataInizioAssenza = convertiStringaInDateSafe(assenza.dataInizio);
      const dataFineAssenza = convertiStringaInDateSafe(assenza.dataFine);
      dataFineAssenza.setHours(23, 59, 59, 999);

      if (dataInizioAssenza <= dateinizio && dataFineAssenza >= datefine) {
        intervalloCopertoDaAssenza = true;

        for (const prenotazione of ombrellone.prenotazioni) {
          if (prenotazione.occupazioneAssenza) {
            const dataFinePrenotazione = convertiStringaInDateSafe(prenotazione.dataFine);
            dataFinePrenotazione.setHours(23, 59, 59, 999);
            const dataInizioPrenotazione =
              prenotazione.Tipo === "Giornaliero"
                ? dataFinePrenotazione
                : convertiStringaInDateSafe(prenotazione.datainizio!);

            const prenotazioneSovrapposta =
              dataInizioPrenotazione <= datefine && dataFinePrenotazione >= dateinizio;

            if (prenotazioneSovrapposta) {
              prenotazioneOccupanteAssenza = prenotazione;
              break;
            }
          }
        }
        break;
      }
    }

    if (intervalloCopertoDaAssenza) {
      return prenotazioneOccupanteAssenza ? prenotazioneOccupanteAssenza : null;
    }

    let prenotazionePiuGrande: Prenotazione | null = null;
    let durataPiuGrande = -1;

    for (const prenotazione of ombrellone.prenotazioni) {
      const dataFinePrenotazione = convertiStringaInDateSafe(prenotazione.dataFine);
      dataFinePrenotazione.setHours(23, 59, 59, 999);

      const dataInizioPrenotazione =
        prenotazione.Tipo === "Giornaliero"
          ? dataFinePrenotazione
          : convertiStringaInDateSafe(prenotazione.datainizio!);

      const isSovrapposta =
        dataInizioPrenotazione <= datefine && dataFinePrenotazione >= dateinizio;

      if (isSovrapposta) {
        let isCompletamenteCopertoDaAssenza = false;

        for (const assenza of ombrellone.Assenze) {
          const dataInizioAssenza = convertiStringaInDateSafe(assenza.dataInizio);
          const dataFineAssenza = convertiStringaInDateSafe(assenza.dataFine);
          dataFineAssenza.setHours(23, 59, 59, 999);

          if (
            dataInizioAssenza <= dataInizioPrenotazione &&
            dataFineAssenza >= dataFinePrenotazione
          ) {
            isCompletamenteCopertoDaAssenza = true;
            break;
          }

          const assenzaSovrapposta =
            dataInizioAssenza <= datefine && dataFineAssenza >= dateinizio;

          if (assenzaSovrapposta && prenotazione.occupazioneAssenza) {
            return prenotazione;
          }
        }

        if (!isCompletamenteCopertoDaAssenza) {
          const durataPrenotazione =
            dataFinePrenotazione.getTime() - dataInizioPrenotazione.getTime();
          if (durataPrenotazione > durataPiuGrande) {
            prenotazionePiuGrande = prenotazione;
            durataPiuGrande = durataPrenotazione;
          }
        }
      }
    }

    if (prenotazionePiuGrande) {
      return prenotazionePiuGrande;
    }

    for (const prenotazione of ombrellone.prenotazioni) {
      if (prenotazione.Tipo === "Stagionale" || prenotazione.Tipo === "Annuale") {
        const dataFinePrenotazione = convertiStringaInDateSafe(prenotazione.dataFine);
        dataFinePrenotazione.setHours(23, 59, 59, 999);
        const dataInizioPrenotazione = convertiStringaInDateSafe(prenotazione.datainizio!);

        const isSovrapposta =
          dataInizioPrenotazione <= datefine && dataFinePrenotazione >= dateinizio;

        if (isSovrapposta) {
          let isCopertoDaAssenza = false;
          for (const assenza of ombrellone.Assenze) {
            const dataInizioAssenza = convertiStringaInDateSafe(assenza.dataInizio);
            const dataFineAssenza = convertiStringaInDateSafe(assenza.dataFine);
            dataFineAssenza.setHours(23, 59, 59, 999);

            if (dataInizioAssenza <= dateinizio && dataFineAssenza >= datefine) {
              isCopertoDaAssenza = true;
              break;
            }
          }
          if (!isCopertoDaAssenza) {
            return prenotazione;
          }
        }
      }
    }

    return null;
  }

  return null;
};

const convertiStringaInDate = (dataStringa: string): Date => {

  const [day, month, year] = dataStringa.split('/');
  return new Date(Number(year), Number(month) - 1, Number(day)); // Mese in JavaScript è 0-based
};
const objectclick = async (e:  React.MouseEvent<HTMLButtonElement>, documento: any, index: number) => {
  setdoccercato(null)
  if (datattuale) {
  if(action == "select" && documento && documento.tipologia === "Ombrellone") {
 
    const padding = 20; // Aggiungi un po' di margine
    const x = e.clientX;
    const y = e.clientY;
console.log(documento)
    const correctedX = Math.min(x, window.innerWidth - 300 - padding); // 300 è la larghezza stimata del motion.div
    const correctedY = Math.min(y, window.innerHeight - 200 - padding); // 200 è l'altezza stimata del motion.div

    setListPosition({ x: correctedX, y: correctedY });
    setSelectedDoc(documento);
    
  }
  if(action === "add") {
  if (documento == null) {
    console.log(aggiungioggetto)
    if(aggiungioggetto == "Ombrellone") {
    try {
      // Creazione dati da aggiungere
      const data = {
        Posizione: index, // Sostituisci con i dati reali
        Tipologia: "Ombrellone", // Sostituisci con i dati reali
        Prenotazioni: [],
        Assenze: []
      };

      // Aggiungi il documento a Firestore
      const docRef = await addDoc(collection(firestore, "Utenti", "regelly150", COLLEZIONE), data);
      console.log("Documento aggiunto con ID: ", docRef.id);
    } catch (error) {
      console.error("Errore durante l'aggiunta del documento: ", error);
      alert("Errore: non è stato possibile aggiungere il documento.");
    }
  
  }else if(aggiungioggetto == "Mattonella") {
    try {
      // Creazione dati da aggiungere
      const data = {
        Posizione: index, // Sostituisci con i dati reali
        Tipologia: "Mattonella", // Sostituisci con i dati reali
        Prenotazioni: []
      };

      // Aggiungi il documento a Firestore
      const docRef = await addDoc(collection(firestore, "Utenti", "regelly150", COLLEZIONE), data);
      console.log("Documento aggiunto con ID: ", docRef.id);
    } catch (error) {
      console.error("Errore durante l'aggiunta del documento: ", error);
      alert("Errore: non è stato possibile aggiungere il documento.");
    }
  }
}
  
  }
  if(action === "Rimuovi" && documento) {
    // Apri il popup di conferma personalizzato (modale in fondo al componente)
    setDaEliminare(documento);
  }
  if(action == "Sposta" && documento && documento.tipologia === "Ombrellone" ) {
   if (!selectedinvertedDoc1) {
    setSelectedinvertedDoc1(documento)
   }else if (selectedinvertedDoc2) {
    setSelectedinvertedDoc1(documento)
    setSelectedinvertedDoc2(null)
   }else{
    setSelectedinvertedDoc2(documento)
   }
  }
}
}
// Eliminazione definitiva, confermata dal popup interno.
const eliminaConfermato = async () => {
  if (daEliminare) {
    const docRef = doc(firestore, "Utenti", "regelly150", COLLEZIONE, daEliminare.id);
    await deleteDoc(docRef);
  }
  setDaEliminare(null);
};
const salva = async () => {

  if (selectedDoc) {
  
    await updateDoc(doc(firestore, "Utenti", "regelly150", COLLEZIONE, selectedDoc?.id), {
      Prenotazioni: selectedDoc.prenotazioni,
      Assenze: selectedDoc.Assenze,
      Tipologia: selectedDoc.tipologia,
    });
  }
setSelectedDoc(null)
}
const Aggingiprenotazione = () => {
  setSelectedDoc((prevDoc: any) => {
    if (!prevDoc ) {
      console.log('Errore: prevDoc è null');
      alert("Errore: documento non trovato");
      return prevDoc;
    }
    if ( Testoaggiungidata === "") {
      alert("Errore: devi inserire un nome alla prenotazione");
      return prevDoc;
    }

    const formattedStartDate = startDate?.toLocaleDateString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }) || '';
    const formattedEndDate = endDate?.toLocaleDateString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }) || '';
    const Testoaggiungidata2 = Testoaggiungidata || '';

    console.log('Input:', { formattedStartDate, formattedEndDate, selectedValue, Testoaggiungidata2 });

    const parseItalianDate = (dateStr: string): Date | null => {
      if (!dateStr) return null;
      const [day, month, year] = dateStr.split('/').map(Number);
      const date = new Date(year, month - 1, day);
      return isNaN(date.getTime()) ? null : date;
    };

    const rangesOverlap = (start1: Date, end1: Date, start2: Date, end2: Date): boolean => {
      return start1 <= end2 && start2 <= end1;
    };

    let newStart: Date | null = null;
    let newEnd: Date | null = null;

    if (selectedValue === "Giornaliero") {
      newEnd = parseItalianDate(formattedEndDate);
      newStart = newEnd;
      if (!newEnd) {
        alert("Errore: selezionare una data valida per la prenotazione giornaliera");
        return prevDoc;
      }
    } else {
      newStart = parseItalianDate(formattedStartDate);
      newEnd = endDate ? parseItalianDate(formattedEndDate) : newStart;
      if (!newStart || (endDate && !newEnd)) {
        alert("Errore: selezionare date valide per la prenotazione");
        return prevDoc;
      }
      if (newStart > newEnd!) {
        alert("Errore: la data di inizio non può essere successiva alla data di fine");
        return prevDoc;
      }
    }

    // Controllo assenze per determinare occupazioneAssenza
    const assenze = prevDoc.Assenze || [];
    let isInAbsencePeriod = false;
    for (const assenza of assenze) {
      const absenceStart = parseItalianDate(assenza.dataInizio);
      const absenceEnd = parseItalianDate(assenza.dataFine);
      if (!absenceStart || !absenceEnd || absenceStart > absenceEnd) continue;

      const inAbsence = selectedValue === "Giornaliero"
        ? newStart! >= absenceStart && newStart! <= absenceEnd
        : rangesOverlap(newStart!, newEnd!, absenceStart, absenceEnd);

      if (inAbsence) {
        isInAbsencePeriod = true;
        break;
      }
    }

    const prenotazioni = prevDoc.prenotazioni || [];

    // Controllo sovrapposizione con prenotazioni esistenti (occupazioneAssenza = false)
    if (!isInAbsencePeriod) {
      for (const prenotazione of prenotazioni) {
        const existingStart = prenotazione.datainizio
          ? parseItalianDate(prenotazione.datainizio)
          : parseItalianDate(prenotazione.dataFine);
        const existingEnd = prenotazione.dataFine
          ? parseItalianDate(prenotazione.dataFine)
          : existingStart;

        if (!existingStart || !existingEnd) continue;

        if (rangesOverlap(newStart!, newEnd!, existingStart, existingEnd)) {
          alert("Le date selezionate si sovrappongono a una prenotazione esistente!");
          return prevDoc;
        }
      }
    }

    // Controllo sovrapposizione con altre prenotazioni con occupazioneAssenza = true
    if (isInAbsencePeriod) {
      for (const prenotazione of prenotazioni) {
        if (!prenotazione.occupazioneAssenza) continue; // Salta quelle con occupazioneAssenza = false

        const existingStart = prenotazione.datainizio
          ? parseItalianDate(prenotazione.datainizio)
          : parseItalianDate(prenotazione.dataFine);
        const existingEnd = prenotazione.dataFine
          ? parseItalianDate(prenotazione.dataFine)
          : existingStart;

        if (!existingStart || !existingEnd) continue;

        if (rangesOverlap(newStart!, newEnd!, existingStart, existingEnd)) {
          alert("Le date selezionate si sovrappongono a un'altra prenotazione in assenza!");
          return prevDoc;
        }
      }
    }

    const occupazioneAssenza = isInAbsencePeriod;
    console.log('Aggiungo prenotazione con occupazioneAssenza:', occupazioneAssenza);

    if (selectedValue !== "Annuale" && selectedValue !== "Stagionale") {
      setEndDate(null);
      setStartDate(null);
    }
    setestoaggiungidata("");

    const newPrenotazione = {
      Nome: Testoaggiungidata2,
      Tipo: selectedValue || "Non specificato",
      occupazioneAssenza,
    };

    if (selectedValue === "Giornaliero") {
      return {
        ...prevDoc,
        prenotazioni: [
          ...prenotazioni,
          {
            ...newPrenotazione,
            dataFine: formattedEndDate,
          },
        ],
      };
    }

    if (newStart) {
      return {
        ...prevDoc,
        prenotazioni: [
          ...prenotazioni,
          {
            ...newPrenotazione,
            datainizio: formattedStartDate,
            dataFine: formattedEndDate || formattedStartDate,
          },
        ],
      };
    }

    return prevDoc;
  });
};
const Aggiungiassenza = () => {
  setSelectedDoc((prevDoc) => {
    if (!prevDoc) {
      console.error("Errore: documento non trovato");
      alert("Errore: documento non trovato");
      return null;
    }

    const parseItalianDate = (dateStr: any) => {
      if (!dateStr) return null;
      const [day, month, year] = dateStr.split('/').map(Number);
      const date = new Date(year, month - 1, day);
      return isNaN(date.getTime()) ? null : date;
    };

    const rangesOverlap = (start1: any, end1: any, start2: any, end2: any) => start1 <= end2 && start2 <= end1;

    const formattedStartDate = startDate?.toLocaleDateString('it-IT') || '';
    const formattedEndDate = endDate?.toLocaleDateString('it-IT') || '';

    let newStart = formattedStartDate ? parseItalianDate(formattedStartDate) : null;
    let newEnd = formattedEndDate ? parseItalianDate(formattedEndDate) : newStart;

    if (!newEnd) {
      alert("Errore: selezionare almeno una data valida per l'assenza");
      return prevDoc;
    }

    if (!newStart) {
      newStart = newEnd;
    }

    if (newStart > newEnd) {
      alert("Errore: la data di inizio non può essere successiva alla data di fine");
      return prevDoc;
    }

    const assenze = prevDoc.Assenze || [];
    const hasOverlap = assenze.some(({ dataInizio, dataFine }) => {
      const existingStart = parseItalianDate(dataInizio);
      const existingEnd = parseItalianDate(dataFine) || existingStart;
      return existingStart && existingEnd && rangesOverlap(newStart, newEnd, existingStart, existingEnd);
    });

    if (hasOverlap) {
      alert("Errore: esiste già un'assenza in questo intervallo di date");
      return prevDoc;
    }

    const prenotazioni = prevDoc.prenotazioni || [];
    const isCompletelyWithinReservation = prenotazioni.some(({ datainizio, dataFine, occupazioneAssenza }) => {
      if (occupazioneAssenza) return false; // Esclude le prenotazioni con occupazioneAssenza = true
      const existingStart = parseItalianDate(datainizio);
      const existingEnd = parseItalianDate(dataFine) || existingStart;
      return (
        existingStart &&
        existingEnd &&
        newStart &&
        newEnd &&
        newStart >= existingStart &&
        newEnd <= existingEnd
      );
    });

    if (!isCompletelyWithinReservation) {
      alert(
        "Errore: l'assenza deve essere completamente contenuta in una prenotazione"
      );
      return prevDoc;
    }

    return {
      ...prevDoc,
      Assenze: [
        ...assenze,
        {
          dataInizio: formattedStartDate || formattedEndDate,
          dataFine: formattedEndDate,
        },
      ],
    };
  });
};

async function swapOmbrelloni() {
  try {
    console.log("YEA")
    // 1️⃣ Recupero i due ombrelloni
    if(selectedinvertedDoc1 && selectedinvertedDoc2) {

      console.log(selectedinvertedDoc1, selectedinvertedDoc2)
    const docRef1 = doc(firestore, "Utenti", "regelly150", COLLEZIONE, selectedinvertedDoc1?.id);
    const docRef2 = doc(firestore, "Utenti", "regelly150", COLLEZIONE, selectedinvertedDoc2?.id);

    const posizione1 = selectedinvertedDoc1.posizione;
    const posizione2 = selectedinvertedDoc2.posizione;

    // Swap diretto delle posizioni senza eliminare
    await updateDoc(docRef1, { Posizione: posizione2 });
    await updateDoc(docRef2, { Posizione: posizione1 });

    setSelectedinvertedDoc1(null)
    setSelectedinvertedDoc2(null)
    console.log("Ombrelloni scambiati con successo!");
  }
  } catch (error) {
    console.error("Errore nello scambio degli ombrelloni:", error);
  }
}
const cancellaprenotazione = (index: number) => {
  setSelectedDoc((prevDoc: any) => {
    if (!prevDoc || !prevDoc.prenotazioni) return prevDoc;

    const prenotazioneDaEliminare = prevDoc.prenotazioni[index];

    // Se occupazioneAssenza è true, elimina sempre la prenotazione senza controlli
    if (prenotazioneDaEliminare.occupazioneAssenza === true) {
      return {
        ...prevDoc,
        prenotazioni: prevDoc.prenotazioni.filter((_: Prenotazione, i: number) => i !== index),
      };
    }

    // Se occupazioneAssenza è false, controlla le sovrapposizioni
    // Parsing della dataFine della prenotazione (obbligatoria)
    const [giornoFinePren, meseFinePren, annoFinePren] = prenotazioneDaEliminare.dataFine.split('/').map(Number);
    const finePren = new Date(annoFinePren, meseFinePren - 1, giornoFinePren);
    finePren.setHours(23, 59, 59, 999); // Fine giornata

    // Parsing della datainizio della prenotazione (se presente), altrimenti usa dataFine
    let inizioPren: any;
    if (prenotazioneDaEliminare.datainizio) {
      const [giornoInizioPren, meseInizioPren, annoInizioPren] = prenotazioneDaEliminare.datainizio.split('/').map(Number);
      inizioPren = new Date(annoInizioPren, meseInizioPren - 1, giornoInizioPren);
    } else {
      inizioPren = finePren; // Se è giornaliera, inizio = fine
    }

    // Controllo se ci sono assenze che si sovrappongono
    const haAssenzeSovrapposte = prevDoc.Assenze?.some((assenza: any) => {
      // Parsing della dataInizio dell'assenza
      const [giornoInizioAss, meseInizioAss, annoInizioAss] = assenza.dataInizio.split('/').map(Number);
      const inizioAssenza = new Date(annoInizioAss, meseInizioAss - 1, giornoInizioAss);

      // Parsing della dataFine dell'assenza
      const [giornoFineAss, meseFineAss, annoFineAss] = assenza.dataFine.split('/').map(Number);
      const fineAssenza = new Date(annoFineAss, meseFineAss - 1, giornoFineAss);
      fineAssenza.setHours(23, 59, 59, 999); // Fine giornata

      // Controllo sovrapposizione
      return inizioPren <= fineAssenza && finePren >= inizioAssenza;
    });

    // Se ci sono assenze sovrapposte e occupazioneAssenza è false, non cancellare
    if (haAssenzeSovrapposte) {
      alert("Impossibile cancellare la prenotazione: Esistono assenze sovrapposte");
      return prevDoc; // Restituisce il documento invariato
    }

    // Cancella la prenotazione se NON ci sono assenze sovrapposte (e occupazioneAssenza è false)
    return {
      ...prevDoc,
      prenotazioni: prevDoc.prenotazioni.filter((_: Prenotazione, i: number) => i !== index),
    };
  });
};
 const cancellaassenza = (index: number) => {  
  setSelectedDoc((prevDoc: any) => {
    if (!prevDoc || !prevDoc.Assenze) return prevDoc;

    const assenzaDaEliminare = prevDoc.Assenze[index];

    // Parsing della data nel formato giorno/mese/anno
    const [giornoInizio, meseInizio, annoInizio] = assenzaDaEliminare.dataInizio.split('/').map(Number);
    const inizioAssenza = new Date(annoInizio, meseInizio - 1, giornoInizio); // mese -1 perché i mesi sono 0-based

    const [giornoFine, meseFine, annoFine] = assenzaDaEliminare.dataFine.split('/').map(Number);
    const fineAssenza = new Date(annoFine, meseFine - 1, giornoFine);
    fineAssenza.setHours(23, 59, 59, 999); // Fine giornata

    const haPrenotazioniSovrapposte = prevDoc.prenotazioni?.some((prenotazione: Prenotazione) => {

      if (!prenotazione.occupazioneAssenza) return false;

      // Parsing della dataFine della prenotazione
      const [giornoFinePren, meseFinePren, annoFinePren] = prenotazione.dataFine.split('/').map(Number);
      const finePren = new Date(annoFinePren, meseFinePren - 1, giornoFinePren);
      finePren.setHours(23, 59, 59, 999); // Fine giornata

      // Parsing della datainizio della prenotazione (se esiste), altrimenti usa dataFine
      let inizioPren;
      if (prenotazione.datainizio) {
        const [giornoInizioPren, meseInizioPren, annoInizioPren] = prenotazione.datainizio.split('/').map(Number);
        inizioPren = new Date(annoInizioPren, meseInizioPren - 1, giornoInizioPren);
      } else {
        inizioPren = finePren;
      }

      console.log(inizioAssenza, finePren, fineAssenza, inizioPren)
      // Controllo sovrapposizione
      return inizioAssenza <= finePren && fineAssenza >= inizioPren;
    });

    if (haPrenotazioniSovrapposte) {
      alert("Impossibile cancellare l'assenza: Esistono OCCUPAZIONI sovrapposte");
      return prevDoc; // Non elimina se ci sono sovrapposizioni
    }

    // Elimina l'assenza solo se NON ci sono sovrapposizioni
    return {
      ...prevDoc,
      Assenze: prevDoc.Assenze.filter((_: Assenza, i: number) => i !== index),
    };   
  });
};


const handleDateChange = (dates: [Date | null, Date | null]) => {
  const [start, end] = dates;
  console.log(start)
  setStartDate(start);

    setEndDate(end);

  console.log(start, end)
};
const handleDateChange2 = (dates: [Date | null, Date | null]) => {
  const [start, end] = dates;
  setdateinizio(start);

    setdatefine(end);

  console.log(start, end)
};
const handletextDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  if (selectedDoc) {
  setestoaggiungidata(e.target.value)
  }
};
const handleSelectChange = (event:React.ChangeEvent<HTMLSelectElement> ) => {
  setSelectedValue(event.target.value);
  if (event.target.value == "Stagionale") {
    setStartDate(new Date(2026, 5, 8)) // 8 Giugno 2026 (mese 5 = giugno, 0-indexed)
    setEndDate(new Date(2026, 8, 13)) // 13 Settembre 2026
  }else if (event.target.value == "Annuale") {
    setStartDate(new Date(2026, 3, 25))
    setEndDate(new Date(2026, 9, 10))
  }else{
    setStartDate(null)
    setEndDate(null)
  }
};
const handleSelectChange2 = (event:React.ChangeEvent<HTMLSelectElement> ) => {
  setaggiungioggetto(event.target.value);
};
const handleSelectChange3 = (event:React.ChangeEvent<HTMLSelectElement> ) => {
  setintervallo(event.target.value);
};

// Disegna un singolo posto della spiaggia in base al suo indice (Posizione).
// Cerca su Firebase il documento con quella Posizione e mostra ombrellone
// occupato/libero, mattonella oppure posto vuoto.
const renderCella = (index: number, pienaCella = false) => {
  const documento = docs.find((doc) => doc.posizione === index);
  const prenotazione = documento ? verificaPrenotazione(documento) : null;

  if (documento?.tipologia === "Mattonella") {
    return (
      <button
        key={index}
        onClick={(e) => objectclick(e, documento, index)}
        className={pienaCella ? "bg-orange-600 w-full h-full" : "bg-orange-600 flex-shrink-0"}
        style={pienaCella ? undefined : { width: `${CELL_VW}vw` }}
      >
        <img src={mattonella} className="object-cover w-full p-0 m-0" alt="Mattonella" />
      </button>
    );
  }

  return (
    <motion.div
      key={index}
      initial={{ scale: 1 }}
      whileHover={{ scale: 1.2 }}
      transition={{ type: "spring", stiffness: 150 }}
      className={
        selectedDoc?.posizione == index || Docercato?.posizione == index
          ? "border-blue-400 border-[2px]"
          : selectedinvertedDoc1?.posizione == index
          ? "border-green-500 border-[1px]"
          : selectedinvertedDoc2?.posizione == index
          ? "border-yellow-600 border-[1px]"
          : "border-[1px] border-transparent"
      }
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0,
        width: `${CELL_VW}vw`,
      }}
    >
      <button onClick={(e) => objectclick(e, documento, index)} className="w-full">
        {documento ? (
          prenotazione ? (
            prenotazione.Tipo === "Giornaliero" ? (
              <div className="flex flex-col items-center w-[100%]">
                <img src={blu} className="bg-transparent" alt="Giornaliero" />
                <p className="text-[0.4vw]">{prenotazione.Nome.length > 6 ? prenotazione.Nome.slice(0, 6) : prenotazione.Nome}</p>
              </div>
            ) : prenotazione.Tipo === "Intervallo" ? (
              <div className="flex flex-col items-center w-[100%]">
                <img src={giallo} className="bg-transparent" alt="Intervallo" />
                <p className="text-[0.4vw]">{prenotazione.Nome.length > 6 ? prenotazione.Nome.slice(0, 6) : prenotazione.Nome}</p>
              </div>
            ) : prenotazione.Tipo === "Stagionale" ? (
              <div className="flex flex-col items-center w-[100%]">
                <img src={arancione} className="bg-transparent" alt="Stagionale" />
                <p className="text-[0.4vw]">{prenotazione.Nome.length > 6 ? prenotazione.Nome.slice(0, 6) : prenotazione.Nome}</p>
              </div>
            ) : prenotazione.Tipo === "Annuale" ? (
              <div className="flex flex-col items-center w-[100%]">
                <img src={rosso} className="bg-transparent" alt="Annuale" />
                <p className="text-[0.4vw]">{prenotazione.Nome.length > 6 ? prenotazione.Nome.slice(0, 6) : prenotazione.Nome}</p>
              </div>
            ) : (
              <div className="flex flex-col items-center w-[100%]">
                <img src={verde} className="bg-transparent" alt="Libero" />
                <p className="text-[0.4vw]">Libero</p>
              </div>
            )
          ) : (
            <div className="flex flex-col items-center w-[100%]">
              <img src={verde} className="bg-transparent" alt="Libero" />
              <p className="text-[0.4vw]">Libero</p>
            </div>
          )
        ) : (
          // Cella VUOTA: alone leggero per indicare dove si può "aggiungere".
          <div
            className="flex flex-col items-center w-[100%]"
            style={{ boxShadow: "inset 0 0 0.28vw rgba(0,0,0,0.15)", borderRadius: "0.3vw" }}
          >
            <img src={vuoto} className="bg-[#aca8a800]" alt="Posto vuoto" />
            <p className="text-[0.4vw]"></p>
          </div>
        )}
      </button>
    </motion.div>
  );
};

// Griglia rettangolare della VERSIONE 1: numero celle = File × Colonne.
// Sanifico i valori (interi >= 0) per evitare RangeError da dati Firestore strani.
const riempiGriglia = () => {
  const f = Math.max(0, Math.floor(Number(docsinfo[0]?.File) || 0));
  const c = Math.max(0, Math.floor(Number(docsinfo[0]?.Colonne) || 0));
  return Array(f * c).fill(null);
};

// La V2 non dipende da docsinfo (usa il LAYOUT statico): basta `loading`.
if (!loading) {
  return null;
}


  return (
    <div  className='flex flex-col h-screen bg-[#ecddb1]  overflow-x-auto'>
    
 <div className="absolute  flex justify-center items-center text-[1.6vw] top-2 w-[100%] space-x-2 h-[3vw] rounded-lg  ">
 <button onClick={() => setMenu(true)} className="flex text-white ml-2 text-[1.5rem]">
    Menu
  </button>
 <div className=" flex flex-1 justify-center">   
 <select
        value={intervallo}
        onChange={handleSelectChange3}
        className="border-[1px] border-[#a1a1a1] py-[0.1rem]   rounded-full px-4"
       
      >
        <option value="Giorno">Giorno</option>
        <option value="Intervallo">Intervallo</option>
      
      </select>
{
  intervallo==="Giorno"? 
  <DatePicker
    selected={date}
    className=" flex w-[10rem]   border-[1px]  py-[0.1rem] border-[#a1a1a1] rounded-full px-4" // Imposta la data di inizio
    onChange={(date: Date | null) => {
      setdate(date);// Update the selected date
    }}  // Funzione chiamata quando l'utente seleziona le date
    dateFormat="dd/MM/yyyy"
    locale={it}
 // Formato data
 // Aggiunge un pulsante per cancellare la selezione
  />
  :
  <DatePicker
  selected={dateinizio}
  className=" flex w-[100%]  border-[1px]  py-[0.1rem] border-[#a1a1a1] rounded-full px-4" // Imposta la data di inizio
  onChange={handleDateChange2} // Funzione chiamata quando l'utente seleziona le date
  dateFormat="dd/MM/yyyy"
  startDate={dateinizio}  // Imposta la data di inizio
  endDate={datefine}  // Imposta la data di fine
  selectsRange
  locale={it}
 // Aggiunge un pulsante per cancellare la selezione
/>
  }
  </div> 
  <div className="flex items-center mr-3 space-x-1 text-[0.9rem]">
    <button
      onClick={() => cambiaVersione(1)}
      style={{ backgroundColor: versione === 1 ? "#ffffff" : "#ffffff33", color: versione === 1 ? "#000000" : "#ffffff" }}
      className="rounded-full px-3 border border-white"
    >
      V1
    </button>
    <button
      onClick={() => cambiaVersione(2)}
      style={{ backgroundColor: versione === 2 ? "#ffffff" : "#ffffff33", color: versione === 2 ? "#000000" : "#ffffff" }}
      className="rounded-full px-3 border border-white"
    >
      V2
    </button>
  </div>
  <p className="text-white pr-2"> Lido Vascello</p>
  
  </div>

     <div onClick={() => setSelectedDoc(null)} className='flex  bg-[#489ed8] h-[5rem] min-w-full text-white text-[1.4rem] p-2'>
   
      </div> 

   
        <AnimatePresence>
        {listPosition && selectedDoc && (
           <div className='absolute top-0  z-[1000] min-h-full w-[100%]  shadow-lg  flex-row flex   font-inter '>

         <motion.div
       initial={{ opacity: 0, y: 0 }} // Inizia invisibile e più in basso
       animate={{ opacity: 1, y: 0 }}   // Diventa visibile e si sposta verso l'alto
       exit={{ opacity: 0, y: 0 }}    // Uscita fluida
       transition={{ duration: 0.2 }}     // Imposta la durata dell'animazione
       className='flex-1 bg-[#000000b0]'
       onClick={() => setSelectedDoc(null)}
      >
      </motion.div>

  <motion.div
       initial={{ opacity: 0, x: listPosition.x > window.innerWidth / 2? -200 : 200 }} // Inizia completamente fuori a sinistra
       animate={{ opacity: 1, x: 0 }}   // Entra nella posizione originale
       exit={{ opacity: 0, x: listPosition.x > window.innerWidth / 2? -200 : 200 }}    // Uscita fluida
       transition={{ duration: 0.2 }} // Transizione più fluida
       className='bg-[#ffffff] text-[#000000] min-h-full px-2 py-2 text-[1.5rem]'
    style={{
      position: "Absolute",
      top: 0,
      left: listPosition.x > window.innerWidth / 2 ? 0 : "auto",
      right: listPosition.x > window.innerWidth / 2 ? "auto" : 0,
      
      zIndex: 9999,
   
    }}
  >

<div className="flex flex-col  w-[30rem] bg-white ">
<div className="flex p-4  flex-col ">
      {/* HEADER*/ }
      <div className="flex  flex-row items-center ">
    <p className="flex flex-1 text-[1.4rem] font-semibold">{selectedDoc.tipologia + " " + selectedDoc.posizione}</p>
    <button onClick={() => setSelectedDoc(null)} className=" text-[1.1rem] text-red-400 font-nomral">Chiudi</button>
    </div>
{/* INFO INIZIALI*/ }

    <div className="flex flex-col space-y-3 mt-4 text-[#616161]">
    
     
      {verificaPrenotazione(selectedDoc)?
             <div className="flex flex-col space-y-3">
        <div className="flex">
       <p className="flex-1 text-[1.1rem]">Nome:</p>
        <p className="font-semibold text-black">{verificaPrenotazione(selectedDoc)?.Nome}</p>
        </div>
        
        </div>
        :
        <div/>
      }

<div className="flex">
      <p className="flex-1 text-[1.1rem]">Disponibilità:</p>
    
        {!verificaPrenotazione(selectedDoc)? 
         <p className="text-[1.1rem] text-green-500 font-semibold">
          Libero
      </p>
        :
        <p className="text-[1.1rem] text-red-500 font-semibold">
          Occupato
      </p>
        }
        
</div>
{verificaPrenotazione(selectedDoc)?
<div className="flex justify-end text-[0.8rem]">
 
 {verificaPrenotazione(selectedDoc)?.Tipo=="Giornaliero"? <p className="font-semibold">Prenotato per {verificaPrenotazione(selectedDoc)?.dataFine} </p> : <p className="font-semibold">Prenotato da {verificaPrenotazione(selectedDoc)?.datainizio}  a {verificaPrenotazione(selectedDoc)?.dataFine} </p>}  

</div>
:
<div/>
}
    </div>

{/* DIVISORE*/ }
 
{/* FUNZIONI*/ }


    </div>


    <div className="flex my-2 w-[100%] h-[1px] bg-[#858585]"/>

{prenotazioneoassenze === "Prenotazioni"?
<div className="flex p-4  flex-col   ">

  <div className="flex flex-row justify-center space-x-2 text-[0.9rem] text-white">
  <button onClick={() => {
    setEndDate(null)
    setStartDate(null)
    setprenotazioneoassenze("Prenotazioni")
  }} style={{ backgroundColor: prenotazioneoassenze==="Prenotazioni" ? "#9243bd" : "#ffffff",  borderColor: prenotazioneoassenze === "Prenotazioni" ? "#9243bd" : "#ffffff",color: prenotazioneoassenze==="Prenotazioni" ? "#ffffff" : "#000000"}} className=" rounded-full px-4">Prenotazioni</button>
  <button onClick={() => {
    setEndDate(null)
    setStartDate(null)
    setprenotazioneoassenze("Assenze")
  }}  className=" rounded-full text-black px-4 ">Assenze</button>
  </div>
  <div className="flex flex-col mt-3 ">

<div className="flex flex-row justify-center space-x-4 ">
  <div className="flex flex-col w-[45%]">
  <p className="text-[1rem] text-[#a3a3a3] font-thin ">Inserisci nome</p>

<input
      className=" border-b-[1px] text-[1rem] pt-[0.75rem] mb-2 border-[#a1a1a1]  px-2 text-start"
            type="text"
            value={Testoaggiungidata}
            onChange={handletextDateChange}
          />

  </div>
  <div className="flex flex-col w-[45%] ">
  <p className="text-[1rem] text-[#a3a3a3] font-thin">Tipologia</p>

          <select
        value={selectedValue}
        onChange={handleSelectChange}
        className=" border-b-[1px] text-[1rem] pt-[0.8rem] border-[#a1a1a1]  px-2 text-start"
       
      >

        <option value="Giornaliero">Giornaliero</option>
        <option value="Intervallo">Intervallo</option>
        <option value="Stagionale">Stagionale</option>
        <option value="Annuale">Annuale</option>
      </select>
      </div>
</div>

<div className="flex flex-row justify-center space-x-4 ">
<div className="flex flex-col w-[45%]">
  <p className="text-[#a3a3a3] font-thin text-[1rem]">Aggiungi data</p>
 { selectedValue === "Giornaliero"?
  <DatePicker
  selected={endDate} 
  className=" flex w-[100%] text-[1rem] border-b-[1px]  border-[#a1a1a1] px-2" // Imposta la data di inizio
  onChange={(date: Date | null) => {
    setEndDate(date); 
 
  }}  // Funzione chiamata quando l'utente seleziona le date
  endDate={endDate} // Imposta la data di inizio  
  dateFormat="dd/MM/yyyy" // Formato data
  locale={it}
/>
:
<DatePicker
  selected={startDate}
  className=" flex w-[100%] text-[1rem]  border-b-[1px]  border-[#a1a1a1] px-2" // Imposta la data di inizio  // Imposta la data di inizio
  onChange={handleDateChange}  // Funzione chiamata quando l'utente seleziona le date
  startDate={startDate}  // Imposta la data di inizio
  endDate={endDate}  // Imposta la data di fine
  selectsRange  // Indica che vogliamo selezionare un intervallo di date
    // Mostra il calendario inline (puoi rimuoverlo se preferisci un calendario a tendina)
  dateFormat="dd/MM/yyyy"  // Formato data
   // Aggiunge un pulsante per cancellare la selezione
   locale={it}
/>
}

  </div>
  <div className="flex flex-col w-[45%]"/>
 </div>
 <div className="flex flex-row justify-center space-x-4 ">

<button onClick={Aggingiprenotazione} className=" w-[45%] px-4 py-1 text-white rounded-full bg-blue-600 text-[1rem]  mt-5 border-2">
  Aggiungi
</button>

<button onClick={salva} className=" w-[45%] px-4 py-1 text-white rounded-full bg-green-400 text-[1rem]  mt-5 border-2">
  Salva tutto
</button>

</div>


</div>
</div>
:
<div className="flex p-4  flex-col   ">
  <div className="flex flex-row justify-center space-x-2 text-[0.9rem] text-white">
  <button onClick={() => {
    setEndDate(null)
    setStartDate(null)
    setprenotazioneoassenze("Prenotazioni")

  }} style={{ backgroundColor: prenotazioneoassenze==="Prenotazioni" ? "#9243bd" : "#ffffff",  borderColor: prenotazioneoassenze === "Prenotazioni" ? "#9243bd" : "#ffffff",color: prenotazioneoassenze==="Prenotazioni" ? "#ffffff" : "#000000"}} className=" rounded-full px-4">Prenotazioni</button>
  <button onClick={() => {
    setEndDate(null)
    setStartDate(null)
    setprenotazioneoassenze("Assenze")
    
  }} style={{ backgroundColor: prenotazioneoassenze==="Assenze" ? "#9243bd" : "#ffffff",  borderColor: prenotazioneoassenze === "Assenze" ? "#9243bd" : "#ffffff", color: prenotazioneoassenze==="Assenze" ? "#ffffff" : "#000000"}} className=" rounded-full text-black px-4 ">Assenze</button>
  </div>

<div className="flex flex-col  mt-3">

 <div className="flex flex-row justify-center space-x-4 ">

  <div className="flex flex-col w-[45%] ">
  <p className="text-[1rem] text-[#a3a3a3] font-thin">Tipologia</p>

          <select
        value="Intervallo"
        onChange={handleSelectChange}
        className=" border-b-[1px] text-[1rem] pt-[0.8rem] border-[#a1a1a1]  px-2 text-start"
       
      >
        <option value="Intervallo">Intervallo</option>
      </select>
      </div>
  <div className="flex flex-col w-[45%]">
  <p className="text-[#a3a3a3] font-thin text-[1rem]">Aggiungi data</p>

<DatePicker
  selected={startDate}
  className=" flex w-[100%] text-[1rem]  border-b-[1px]  border-[#a1a1a1] px-2" // Imposta la data di inizio  // Imposta la data di inizio
  onChange={handleDateChange}  // Funzione chiamata quando l'utente seleziona le date
  startDate={startDate}  // Imposta la data di inizio
  endDate={endDate}  // Imposta la data di fine
  selectsRange  // Indica che vogliamo selezionare un intervallo di date
    // Mostra il calendario inline (puoi rimuoverlo se preferisci un calendario a tendina)
  dateFormat="dd/MM/yyyy"  // Formato data
   // Aggiunge un pulsante per cancellare la selezione
   locale={it}
/>


      </div>

 </div>

 <div className="flex flex-row justify-center space-x-4 ">

  <button onClick={Aggiungiassenza} className=" w-[45%] px-4 py-1 text-white rounded-full bg-red-400 text-[1rem]  mt-5 border-2">
   Crea assenza 
  </button>

  <button onClick={salva} className=" w-[45%] px-4 py-1 text-white rounded-full bg-green-400 text-[1rem]  mt-5 border-2">
   Salva tutto
  </button>

 </div>
</div>

</div>
}



 
{/* FUNZIONI*/ }





<div className="flex my-2 w-[100%] h-[1px] bg-[#858585]"/>







 
{/*PRENOTAZIONI*/ }




<div className="mt-2 w-[100%] p-4  overflow-y-auto ">

{
  prenotazioneoassenze === "Prenotazioni" ?
  <p>Prenotazioni attuali</p>
  :
    <p>Assenze attuali</p>
}


{prenotazioneoassenze === "Prenotazioni" ? (
    selectedDoc.prenotazioni.length > 0 ? (
      <div>
        {(() => {
        // Funzione per verificare se una prenotazione rientra nell'intervallo di un'altra
        const isWithinRange = (prenotazioneAssenza: any, prenotazionePrincipale: any) => {
          const parseDate = (dateStr: any) => new Date(dateStr.split('/').reverse().join('-'));

          const assStart = prenotazioneAssenza.datainizio
            ? parseDate(prenotazioneAssenza.datainizio)
            : parseDate(prenotazioneAssenza.dataFine);
          const assEnd = prenotazioneAssenza.dataFine
            ? parseDate(prenotazioneAssenza.dataFine)
            : assStart;

          const prinStart = prenotazionePrincipale.datainizio
            ? parseDate(prenotazionePrincipale.datainizio)
            : parseDate(prenotazionePrincipale.dataFine);
          const prinEnd = prenotazionePrincipale.dataFine
            ? parseDate(prenotazionePrincipale.dataFine)
            : prinStart;

          return assStart >= prinStart && assEnd <= prinEnd;
        };

        // Raggruppa le prenotazioni inline
        const prenotazioniPrincipali = selectedDoc.prenotazioni
          .map((prenotazione, originalIndex) => ({ prenotazione, originalIndex }))
          .filter(({ prenotazione }) => !prenotazione.occupazioneAssenza)
          .sort((a, b) => {
            const dateA = a.prenotazione.dataFine.split('/').reverse().join('-');
            const dateB = b.prenotazione.dataFine.split('/').reverse().join('-');
            return new Date(dateA).getTime() - new Date(dateB).getTime();
          });

        const prenotazioniAssenze = selectedDoc.prenotazioni
          .map((prenotazione, originalIndex) => ({ prenotazione, originalIndex }))
          .filter(({ prenotazione }) => prenotazione.occupazioneAssenza);

        // Renderizza le prenotazioni
        return prenotazioniPrincipali.map(({ prenotazione, originalIndex }) => {
          const prenotazioniAnnidate = prenotazioniAssenze.filter(({ prenotazione: assPren }) =>
            isWithinRange(assPren, prenotazione)
          );

          return (
            <div
              key={originalIndex}
              className="flex flex-col p-2 border-b border-gray-300"
            >
              {/* Prenotazione principale */}
              <div className="flex flex-row">
                <div className="flex-1">
                  {prenotazione.Tipo === "Giornaliero" ? (
                    <div className="flex flex-row">
                      <div className="flex flex-col">
                        <p className="text-[1rem] font-medium text-blue-500">GIORNALIERO</p>
                        <p className="text-[0.8rem]">Prenotato il {prenotazione.dataFine}</p>
                      </div>
                      <div className="flex flex-1 flex-col text-[1rem] items-center justify-center align-middle">
                        <p className="font-semibold">{prenotazione.Nome}</p>
                      </div>
                    </div>
                  ) : prenotazione.Tipo === "Intervallo" ? (
                    <div className="flex flex-row">
                      <div className="flex flex-col">
                        <p className="text-[1rem] font-medium text-yellow-500">INTERVALLO</p>
                        <p className="text-[0.8rem]">
                          Dal {prenotazione.datainizio} al {prenotazione.dataFine}
                        </p>
                      </div>
                      <div className="flex flex-1 flex-col text-[1rem] items-center justify-center align-middle">
                        <p className="font-semibold">{prenotazione.Nome}</p>
                      </div>
                    </div>
                  ) : prenotazione.Tipo === "Stagionale" ? (
                    <div className="flex flex-row">
                      <div className="flex flex-col">
                        <p className="text-[1rem] font-medium text-orange-500">STAGIONALE</p>
                        <p className="text-[0.8rem]">
                          Dal {prenotazione.datainizio} al {prenotazione.dataFine}
                        </p>
                      </div>
                      <div className="flex flex-1 flex-col text-[1rem] items-center justify-center align-middle">
                        <p className="font-semibold">{prenotazione.Nome}</p>
                      </div>
                    </div>
                  ) : prenotazione.Tipo === "Annuale" ? (
                    <div className="flex flex-row">
                      <div className="flex flex-col">
                        <p className="text-[1rem] font-medium text-red-700">ANNUALE</p>
                        <p className="text-[0.8rem]">
                          Dal {prenotazione.datainizio} al {prenotazione.dataFine}
                        </p>
                      </div>
                      <div className="flex flex-1 flex-col text-[1rem] items-center justify-center align-middle">
                        <p className="font-semibold">{prenotazione.Nome}</p>
                      </div>
                    </div>
                  ) : null}
                </div>
                <button
                  onClick={() => cancellaprenotazione(originalIndex)}
                  className="text-red-700 text-[1rem]"
                >
                  Cancella
                </button>
              </div>

              {/* Prenotazioni annidate con occupazioneAssenza = true */}
              {prenotazioniAnnidate.length > 0 && (
                <div className="ml-4 mt-2 border-l-2 border-gray-400 pl-4">
                  {prenotazioniAnnidate.map(({ prenotazione: assPren, originalIndex: assIndex }) => (
                    <div
                      key={assIndex}
                      className="flex flex-row p-1 border-b border-gray-200"
                    >
                      <div className="flex-1">
                        {assPren.Tipo === "Giornaliero" ? (
                          <div className="flex flex-row">
                            <div className="flex flex-col">
                              <p className="text-[0.9rem] font-medium text-blue-400">
                                GIORNALIERO (Assenza)
                              </p>
                              <p className="text-[0.7rem]">Prenotato il {assPren.dataFine}</p>
                            </div>
                            <div className="flex flex-1 flex-col text-[0.9rem] items-center justify-center align-middle">
                              <p className="font-semibold">{assPren.Nome}</p>
                            </div>
                          </div>
                        ) : assPren.Tipo === "Intervallo" ? (
                          <div className="flex flex-row">
                            <div className="flex flex-col">
                              <p className="text-[0.9rem] font-medium text-yellow-400">
                                INTERVALLO (Assenza)
                              </p>
                              <p className="text-[0.7rem]">
                                Dal {assPren.datainizio} al {assPren.dataFine}
                              </p>
                            </div>
                            <div className="flex flex-1 flex-col text-[0.9rem] items-center justify-center align-middle">
                              <p className="font-semibold">{assPren.Nome}</p>
                            </div>
                          </div>
                        ) : assPren.Tipo === "Stagionale" ? (
                          <div className="flex flex-row">
                            <div className="flex flex-col">
                              <p className="text-[0.9rem] font-medium text-orange-400">
                                STAGIONALE (Assenza)
                              </p>
                              <p className="text-[0.7rem]">
                                Dal {assPren.datainizio} al {assPren.dataFine}
                              </p>
                            </div>
                            <div className="flex flex-1 flex-col text-[0.9rem] items-center justify-center align-middle">
                              <p className="font-semibold">{assPren.Nome}</p>
                            </div>
                          </div>
                        ) : assPren.Tipo === "Annuale" ? (
                          <div className="flex flex-row">
                            <div className="flex flex-col">
                              <p className="text-[0.9rem] font-medium text-red-600">
                                ANNUALE (Assenza)
                              </p>
                              <p className="text-[0.7rem]">
                                Dal {assPren.datainizio} al {assPren.dataFine}
                              </p>
                            </div>
                            <div className="flex flex-1 flex-col text-[0.9rem] items-center justify-center align-middle">
                              <p className="font-semibold">{assPren.Nome}</p>
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <button
                        onClick={() => cancellaprenotazione(assIndex)}
                        className="text-red-600 text-[0.9rem]"
                      >
                        Cancella
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        });
      })()}
      </div>
    ) : (
      <div className="flex justify-center text-[#7a7a7a] text-[0.8rem] mt-4 h-[100%] items-center">
        Ancora nessuna prenotazione...
      </div>
    )
  ) : (
    selectedDoc.Assenze.length > 0 ? (
      <div >
 {selectedDoc.Assenze
              .sort((a, b) => {
                const dateA = a.dataFine.split("/").reverse().join("-");
                const dateB = b.dataFine.split("/").reverse().join("-");
                return new Date(dateA).getTime() - new Date(dateB).getTime();
              })
              .map((assenza, index) => (
                <div key={index} className="flex flex-row p-2 mt-3  rounded-full bg-red-300 ">
                  <div className="flex-1 items-center justify-center align-middle">
                    <p className=" text px-3 text-white text-[0.8rem]">Da: {assenza.dataInizio} a: {assenza.dataFine}</p>
                  </div>
                  <button onClick={() => cancellaassenza(index)} className="text-black text-[0.8rem] px-3">ELIMINA</button>
                </div>
              ))}
      </div>
    ) : (
      <div className="flex justify-center text-[0.8rem] mt-4 text-[#7a7a7a] h-[100%] items-center">
        Ancora nessuna assenza inserita...
      </div>
    )
  )}



  </div>
</div>


    


  </motion.div>
  </div>
  )}
  </AnimatePresence>

  <AnimatePresence>
      {Menu && (
           <div className='absolute top-0  z-[1000] min-h-full w-[100%]  shadow-lg  flex-row flex   font-inter '>

         <motion.div
       initial={{ opacity: 0, y: 0 }} // Inizia invisibile e più in basso
       animate={{ opacity: 1, y: 0 }}   // Diventa visibile e si sposta verso l'alto
       exit={{ opacity: 0, y: 0 }}    // Uscita fluida
       transition={{ duration: 0.2 }}     // Imposta la durata dell'animazione
       className='flex-1 bg-[#000000b0]'
       onClick={() => setMenu(false)}
      >
      </motion.div>

  <motion.div
       initial={{ opacity: 0, x:  -200 }} // Inizia completamente fuori a sinistra
       animate={{ opacity: 1, x: 0 }}   // Entra nella posizione originale
       exit={{ opacity: 0, x:  -200 }}    // Uscita fluida
       transition={{ duration: 0.2 }} // Transizione più fluida
       className='bg-[#ffffff] text-[#000000] min-h-full px-2 py-2 text-[1.5rem]'
    style={{
      position: "Absolute",
      top: 0,
      left:  0,
      right:  "auto",
      
      zIndex: 9999,
   
    }}
  >

<div className="flex flex-col items-start  w-[30rem] bg-white overflow-y-auto h-[98vh]">
<p>Impostazioni</p>
<div className="flex flex-row justify-center items-center w-[100%] space-x-6"> <button onClick={() => setimpostazioni("Anagrafica")} className="bg-slate-100 rounded-lg p-1 text-[1rem]">Anagrafica</button><button onClick={() => setimpostazioni("Entrate/Uscite")} className="bg-slate-100 rounded-lg p-1 text-[1rem]">Entrate/Uscite</button></div>
  
  {impostazioni==="Entrate/Uscite" && intervallo === "Giorno" &&
  <>
  <p className="text-[1rem] mt-10 bg-white  rounded-full text-[#000]  px-2">Entrate/Uscite</p>
<div className=" w-[100%] overflow-auto flex flex-row space-x-5">

{date && (
  <div className="w-[50%]">

{risultatiuscite.map((ombrellone) =>

<button onClick={() => visualizzaPrenotazione(ombrellone)} className="flex flex-col w-[100%] items-start  rounded-[10px] my-1 text-white p-1  text-[1rem] bg-red-400">
  <p className="font-bold">USCITA</p>
<p>{getNomiUscite(ombrellone)}</p>
  </button>


  )}

  </div>
)
}
{date && (
  <div className="w-[50%]">
{RisultatiEntrate.map((ombrellone) =>

<button  onClick={() => visualizzaPrenotazione(ombrellone)}  className="flex flex-col w-[100%] items-start  rounded-[10px] my-1 text-white p-1  text-[1rem] bg-green-400" >
  <p className="font-bold">ENTRATA</p>
<p>{getNomiEntrate(ombrellone)}</p>
  </button>
  
  )}

  </div>
)
}
</div>
</>
}
  {impostazioni==="Anagrafica" &&
  <>
<p className="text-[1rem] mt-10 bg-white  rounded-full text-[#000]  px-2">Anagrafica</p>


<div className="flex w-[100%] px-16  items-center justify-center ">

<input
        type="text"
        id="nome"
        className=" flex-1 border-2 rounded-full text-[1rem] px-2 mt-2"
        name="nome"
        placeholder="Cerca un utente"
        value={cerca}
        onChange={handleChange}
      />
</div>

{risultati.map((ombrellone) =>
  ombrellone.prenotazioni.map((prenotazione, index) => {
    if (!prenotazione.Nome.toLowerCase().startsWith(cerca.toLowerCase())) return null;

    return (
      <div key={`${ombrellone.id}-${index}`} className="flex flex-row  w-[100%] my-2 border p-2 rounded">
        <div className="flex-1">
          {prenotazione.Tipo === "Giornaliero" ? (
            <div className="flex flex-row">
              <div className="flex flex-col">
                <p className="text-[1rem] font-medium text-blue-500">GIORNALIERO</p>
                <p className="text-[0.8rem]">Prenotato il {prenotazione.dataFine}</p>
              </div>
              <div className="flex flex-1 flex-col text-[1rem] items-center justify-center align-middle">
                <p className="font-semibold">{prenotazione.Nome}</p>
              </div>
            </div>
          ) : prenotazione.Tipo === "Intervallo" ? (
            <div className="flex flex-row">
              <div className="flex flex-col">
                <p className="text-[1rem] font-medium text-yellow-500">INTERVALLO</p>
                <p className="text-[0.8rem]">
                  Dal {prenotazione.datainizio} al {prenotazione.dataFine}
                </p>
              </div>
              <div className="flex flex-1 flex-col text-[1rem] items-center justify-center align-middle">
                <p className="font-semibold">{prenotazione.Nome}</p>
              </div>
            </div>
          ) : prenotazione.Tipo === "Stagionale" ? (
            <div className="flex flex-row">
              <div className="flex flex-col">
                <p className="text-[1rem] font-medium text-orange-500">STAGIONALE</p>
                <p className="text-[0.8rem]">
                  Dal {prenotazione.datainizio} al {prenotazione.dataFine}
                </p>
              </div>
              <div className="flex flex-1 flex-col text-[1rem] items-center justify-center align-middle">
                <p className="font-semibold">{prenotazione.Nome}</p>
              </div>
            </div>
          ) : prenotazione.Tipo === "Annuale" ? (
            <div className="flex flex-row">
              <div className="flex flex-col">
                <p className="text-[1rem] font-medium text-red-700">ANNUALE</p>
                <p className="text-[0.8rem]">
                  Dal {prenotazione.datainizio} al {prenotazione.dataFine}
                </p>
              </div>
              <div className="flex flex-1 flex-col text-[1rem] items-center justify-center align-middle">
                <p className="font-semibold">{prenotazione.Nome}</p>
              </div>
            </div>
          ) : null}
        </div>
        <button
     onClick={() => visualizzaPrenotazione(ombrellone)}
          className="text-blue-600 text-[1rem] underline"
        >
          Visualizza
        </button>
      </div>
    );
  })
)}

</>
}
</div>


    


  </motion.div>
  </div>
      )
}
  </AnimatePresence>

      {/* POPUP di conferma eliminazione (interno all'app, non quello del browser) */}
      <AnimatePresence>
        {daEliminare && (
          <div className="fixed inset-0 z-[2000] flex items-center justify-center font-inter">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.15 }}
              className="absolute inset-0 bg-[#000000a0]"
              onClick={() => setDaEliminare(null)}
            />
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.15 }}
              className="relative bg-white rounded-2xl px-8 py-6 shadow-2xl flex flex-col items-center w-[26rem] max-w-[90%]"
            >
              <p className="text-[1.4rem] font-semibold mb-2">Conferma eliminazione</p>
              <p className="text-[1rem] text-[#5b5b5b] text-center mb-6">
                Vuoi eliminare{" "}
                <span className="font-semibold">
                  {daEliminare.tipologia} {daEliminare.posizione}
                </span>
                ?<br />
                L'operazione è irreversibile.
              </p>
              <div className="flex flex-row space-x-3 w-full justify-center">
                <button
                  onClick={() => setDaEliminare(null)}
                  className="px-6 py-2 rounded-full border-2 border-[#cfcfcf] text-[1rem] text-[#333]"
                >
                  Annulla
                </button>
                <button
                  onClick={eliminaConfermato}
                  className="px-6 py-2 rounded-full bg-red-500 text-white text-[1rem] font-semibold"
                >
                  Elimina
                </button>
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>

      {/* VERSIONE 1: griglia vecchia rettangolare (File × Colonne dal progetto) */}
      {versione === 1 && (
        <div
          className="grid mt-10 no-select"
          style={{
            gridTemplateColumns: `repeat(${docsinfo[0]?.File}, 1fr)`,
            gridTemplateRows: `repeat(${docsinfo[0]?.Colonne}, 1fr)`,
          }}
        >
          {riempiGriglia().map((_, index) => (
            <div
              key={index}
              style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
            >
              {renderCella(index, true)}
            </div>
          ))}
        </div>
      )}

      {/* VERSIONE 2: nuovo layout (3 aree + scacchiera + 6 file lunghe il lido) */}
      {versione === 2 && (
      <div className="flex flex-col items-center mt-10 no-select">
      <div className="flex flex-row justify-center items-stretch" style={{ gap: `${GAP_OUTER_VW}vw` }}>
        {LAYOUT.map((zona, zi) => (
          <React.Fragment key={zona.nome}>
            {/* Divisore verticale di mattonelle tra un'area e la successiva */}
            {zi > 0 && (
              <div className="self-stretch flex flex-col items-center" style={{ width: `${CELL_VW}vw` }}>
                <p className="text-[1vw] font-semibold mb-2 invisible" aria-hidden>.</p>
                <div
                  className="flex-1 w-full"
                  style={{
                    backgroundImage: `url(${mattonella})`,
                    backgroundRepeat: "repeat-y",
                    backgroundSize: `${CELL_VW}vw auto`,
                    backgroundPosition: "center top",
                  }}
                />
              </div>
            )}

            <div className="flex flex-col items-center">
              <p className="text-[1vw] font-semibold mb-2 text-[#7a5c2e]">{zona.nome}</p>
              <div className="flex flex-col">
                {zona.file.map((fila, fi) => (
                  <div
                    key={fi}
                    className="flex flex-col"
                    style={{ rowGap: `${GAP_VW}vw`, marginTop: fi === 0 ? 0 : `${GAP_VW * 3}vw` }}
                  >
                    {fila.lines.map((line, li) => (
                      // Ogni linea occupa l'intera larghezza dell'area; la fila
                      // "dietro" è spostata di mezzo passo → effetto scacchiera.
                      <div
                        key={li}
                        className="flex flex-row"
                        style={{ columnGap: `${line.gapVw}vw`, marginLeft: `${line.marginLeftVw}vw` }}
                      >
                        {line.slots.map((s) => renderCella(s))}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>

      {/* SOTTO: 6 file dritte (in linea, niente scacchiera) lunghe tutto il lido */}
      <div
        className="flex flex-col"
        style={{ width: `${TOTAL_W}vw`, rowGap: `${GAP_VW * 3}vw`, marginTop: `${GAP_VW * 4}vw` }}
      >
        {BOTTOM_LINES.map((slots, r) => (
          <div key={r} className="flex flex-row" style={{ columnGap: `${BOTTOM_GAP_VW}vw` }}>
            {slots.map((s) => renderCella(s))}
          </div>
        ))}
      </div>
      </div>
      )}

  
    
  <div className="absolute flex items-center px-4  bottom-2 left-1/2  h-[3rem] space-x-3 rounded-full bg-slate-100 transform -translate-x-1/2 -translate-y-1/2">
  <button style={{backgroundColor: action === "select"? "#2670b4" : "#aca8a81a", color: action === "select"? "#ffffff" : "#000000"}} onClick={() => setaction("select")} className=" border-[3px] p-1 rounded-full px-2 ">Seleziona</button>
  <div style={{backgroundColor: action === "add"? "#2670b4" : "#aca8a81a"}} className="border-[3px] p-1 rounded-full px-2 ">
  <button style={{ color: action === "add"? "#ffffff" : "#000000"}} className="mr-3" onClick={() => setaction("add")}>Aggiungi</button>
  <select
        value={aggiungioggetto}
        onChange={handleSelectChange2}
        className="border-[1px] border-[#a1a1a1]   rounded-[5px] px-2"
       
      >
        <option value="Ombrellone">Ombrellone</option>
        <option value="Mattonella">Mattonella</option>
      
      </select>
      </div>
      <div style={{backgroundColor: action === "Sposta"? "#2670b4" : "#aca8a81a"}} className="border-[3px] p-1 rounded-full px-2 ">

  <button style={{ color: action === "Sposta"? "#ffffff" : "#000000"}} className="mr-3" onClick={() => setaction("Sposta")}>Sposta ombrelloni</button>
{
  selectedinvertedDoc1 && selectedinvertedDoc2? 
  <button style={{ color: action === "Sposta"? "#ffffff" : "#000000"}} className=" bg-green-400 mr-3 rounded-full px-2" onClick={swapOmbrelloni}>Scambia</button>
  :
  <div></div>
}

      </div>
      <div style={{backgroundColor: action === "Rimuovi"? "#2670b4" : "#aca8a81a"}} className="border-[3px] p-1 rounded-full px-2 ">
      <button style={{ color: action === "Sposta"? "#ffffff" : "#000000"}} className="mr-3" onClick={() => setaction("Rimuovi")}>Rimuovi</button>
      </div>
  </div>

     

    </div>
  )
}


export default Home;